import { render } from "./base-tabs-panel.vue?vue&type=template&id=93555d0e"
import script from "./base-tabs-panel.vue?vue&type=script&lang=js"
export * from "./base-tabs-panel.vue?vue&type=script&lang=js"
script.render = render

export default script